import React from 'react';
import DaumPostcode from "react-daum-postcode";
import axios from "axios";

const PopupPostCode = (props) => {
    const handlePostCode = (data) => {
        let fullAddress = data.address;
        let extraAddress = ''; 
        
        if (data.addressType === 'R') {
          if (data.bname !== '') {
            extraAddress += data.bname;
          }
          if (data.buildingName !== '') {
            extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
          }
          fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        
        let url = "https://dapi.kakao.com/v2/local/search/address.json?query=" + data.roadAddress
        let url2 = "https://dapi.kakao.com/v2/local/geo/coord2regioncode.json?"
        let jibunAddress
        if(data.jibunAddress !== "" && data.jibunAddress !== null && data.jibunAddress !== undefined) {
          jibunAddress = data.jibunAddress
        } else {
          jibunAddress = data.autoJibunAddress
        }

        const arr = jibunAddress.split(' ');
        const roadArr = data.roadAddress.split(' ');
        const roadData = roadArr.length === 3 ? roadArr[1] : `${roadArr[1]} ${roadArr[2]}`
        
        var road = document.getElementById("road");
        road.value = data.roadAddress;

        axios.get(url,
          {
            headers: {Authorization: "KakaoAK 7877170379e76530c72097c01a586c13"}
          }
        ).then(function(response) {
          let data = response.data.documents
          for(var i = 0;data.length > i; i++) {
            if(
              data[i].road_address.region_1depth_name === roadArr[0]
            ) {
              var lat = document.getElementById("lat");
              lat.value = Number(data[i].y).toFixed(8);
              var lng = document.getElementById("lng");
              lng.value = Number(data[i].x).toFixed(8);

              axios.get(url2 + `x=${Number(data[i].x).toFixed(8)}&y=${Number(data[i].y).toFixed(8)}`, {
                headers: {Authorization: "KakaoAK b2b45047ac120f3f4b57595b43cb4161"}
              }).then(function(response) {
                let jibunData = response.data.documents[1]
                var jibun = document.getElementById("jibun");
                let jibunValue = ""


                for(var j = 0; arr.length > j; j++) {
                  if(j === 2) {
                    jibunValue += jibunData.region_3depth_name + " "
                  } else {
                    jibunValue += arr[j] + " "
                  }
                }

                jibunValue = jibunValue.slice(0, -1)
                jibun.value = jibunValue;
              })
            }
          }
        }).catch(function(error) {
          console.log(error)
        })

        props.onClose()
    }
 
    const postCodeStyle = {
        display: "block",
        width: "340px",
        height: "600px",
      };
 
    return(
        <div className='popup'>
            <div className='popupBox'>
              <div className="popupTitle">
                <h2>주소 검색</h2>
              </div>
              <div className='popupContent'>
                <DaumPostcode style={postCodeStyle} onComplete={handlePostCode} />
                <div className='btnBox'>
                  <button type='button' onClick={() => {props.onClose()}} className='postCode_btn'>닫기</button>
                </div>
              </div>
            </div>
        </div>
    )
}
 
export default PopupPostCode;